const MinisterHelper = {
  empty: () => ({
      first_name: '',
      middle_name: '',
      last_name: '',
      dob: '',
      street_address: '',
      city: '',
      state_id: -1,
      zip: '',
      country_id: 1,
      phone: '',
      email: '',
      password: '',
      password_confirmation: '',
      gender: '',
      id: '',
      newsletter_opt_in: false
  }),

  fullName: (minister) => {
    return [minister.first_name, minister.middle_name, minister.last_name]
      .reduce((acc, name) => {
        const trimmed = name.trim();
        if (trimmed) {
          acc.push(trimmed);
        }

        return acc;
      }, []).join(' ');
  }
};

export default MinisterHelper;
